/**
 * Deprecated. Use utils/src/log instead.
 * @type {Log}
 */
module.exports = require('_common/utils/src/log');
